var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.318182 0.00732422H13.6818C13.8575 0.00732422 14 0.144218 14 0.313574V9.50107C14 9.67043 13.8575 9.80733 13.6818 9.80733H0.318182C0.142227 9.80733 0 9.67043 0 9.50107V0.313574C0 0.144218 0.142227 0.00732422 0.318182 0.00732422ZM9.42196 4.66054L13.3636 8.45405V0.619873H0.636322V8.45405L4.57796 4.66054L5.02787 5.09357L0.766777 9.19487H13.2331L8.97205 5.09357L9.42196 4.66054Z",
    fill: "#0AA1E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2927 0.00734997L7 5.56153L0.7 -1.33514e-06L0.35 0.00734863L0 0.256653L6.75255 6.21676C6.8894 6.33755 7.1106 6.33755 7.24745 6.21676L14 0.256653L13.65 0.00734863L13.2927 0.00734997Z",
    fill: "#0AA1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.318182 0.00732422H13.6818C13.8575 0.00732422 14 0.144218 14 0.313574V9.50107C14 9.67043 13.8575 9.80732 13.6818 9.80732H0.318182C0.142227 9.80732 0 9.67043 0 9.50107V0.313574C0 0.144218 0.142227 0.00732422 0.318182 0.00732422ZM9.42196 4.66054L13.3636 8.45405V0.619873H0.636322V8.45405L4.57796 4.66054L5.02787 5.09357L0.766777 9.19487H13.2331L8.97205 5.09357L9.42196 4.66054Z",
    fill: "#0AA1E2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.45f593bab11ac3adaae65220ea6496f5.svg";
export { ForwardRef as ReactComponent };